import { atom } from 'jotai';
import type { Dashboard } from '@shared/types/dashboard.types';

// Atom for storing all dashboards for the current user/org
export const dashboardsAtom = atom<Dashboard[]>([]);

// Atom for loading state while fetching dashboards
export const dashboardsLoadingAtom = atom<boolean>(true);

// Atom for the currently selected/viewed dashboard (can be null if none selected)
export const currentDashboardAtom = atom<Dashboard | null>(null);

// Atom to trigger a refresh of the dashboards list
export const refreshDashboardsAtom = atom(0);

// Derived atom for dashboard count
export const dashboardCountAtom = atom((get) => get(dashboardsAtom).length);

// Atom for managing the state of the create/edit dashboard dialog
export const dashboardFormDialogAtom = atom<{
  isOpen: boolean;
  mode: 'create' | 'edit';
  dashboard?: Dashboard | null; // Dashboard data for editing
}> ({
  isOpen: false,
  mode: 'create',
  dashboard: null,
}); 